import { Injectable, Injector } from '@angular/core';
import { Router, RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';

@Injectable()
export class PageTitleStrategy extends TitleStrategy {
  private title: Title;
  private translateService: TranslateService;

  constructor(private readonly injector: Injector) {
    super();
  }

  updateTitle(snapshot: RouterStateSnapshot): void {
    if (!this.title) {
      this.title = this.injector.get(Title);
    }
    if (!this.translateService) {
      this.translateService = this.injector.get(TranslateService);
    }
    const title = this.buildTitle(snapshot);

    if (title) {
      this.title.setTitle(this.translateService.instant(title));
    }
  }
}
